export default async function (context) {
  if (context.getters.staff === null) {
    await context.dispatch('staff/fetchStaff')
  }
}
